<template>
  <div class="prefooter" ref="prefooter">
    <div class="container">
      <div class="row footer" :class="{hovered: isHover}">
        <div @click="savePdf()" class="footer__item-download">
          <svg width="37" height="50" viewBox="0 0 37 50"
          fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1.51113 0C0.676709 0 0.000271502 0.678387
            0.000265108 1.51522L0 36.3639C-3.06158e-06 36.7658 0.159176 37.1512
            0.442519 37.4354C0.725862 37.7195 1.11016 37.8792 1.51087
            37.8792H13.5972V34.8487H3.02175L3.02199 3.03047H25.6922C27.9648
            5.30303 30.3113 7.57576 33.3419 10.6063L33.3417 34.8487H22.662V37.8792H34.8525C35.6869
            37.8792 36.3634 37.2008 36.3634 36.3639L36.3636 9.30627C36.3636 9.03362 36.2904
            8.76858 36.1548 8.53761C36.0803 8.3471 35.9668 8.17021 35.8167 8.01967L28.2714
            0.443847C27.9581 0.129673 27.5304 -0.0248678 27.1037 0.00325872C27.0709 0.00109284
            27.0378 0 27.0047 0H1.51113Z" fill="#E30713"></path>
            <path d="M13.1544 41.3531C12.5644 40.7614 11.608 40.7614 11.018 41.3531C10.4281
            41.9447 10.4281 42.904 11.018 43.4956L17.0612 49.5563C17.6511 50.1479 18.6076 50.1479
            19.1975 49.5563L25.2407 43.4956C25.8307 42.904 25.8307 41.9447 25.2407 41.3531C24.6508
            40.7614 23.6943 40.7614 23.1044 41.3531L19.64 44.8274V30.303C19.64 29.4663 18.9637
            28.788 18.1294 28.788C17.2951 28.788 16.6187 29.4663 16.6187 30.303V44.8274L13.1544
            41.3531Z" fill="#E30713"></path>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.57568 25.7423H9.93829V22.813C9.93829
            22.813 10.5289 23.1059 11.2673 23.1059C13.1869 23.1059 14.0729 21.9342 14.0729
            20.4696C14.0729 19.5908 14.0729 18.712 14.0729 17.9797C14.0729 16.515 13.1869
            15.3433 11.7102 15.3433C10.6766 15.3433 9.79063 16.0756 9.79063 16.0756L9.64297
            15.4898H7.57568V25.7423ZM11.7102 20.3231C11.7102 20.616 11.4149 21.0554 10.9719
            21.0554C10.3813 21.0554 9.93829 20.909 9.93829 20.909V17.8332C9.93829 17.8332
            10.5289 17.3938 10.9719 17.3938C11.5626 17.3938 11.7102 17.8332 11.7102 17.9797C11.8579
            18.8585 11.8579 19.5908 11.7102 20.3231ZM21.7513 12.414H19.3887V15.6362C19.3887 15.6362
            18.7981 15.3433 18.0598 15.3433C16.1401 15.3433 15.2542 16.515 15.2542 17.9797C15.2542
            18.8585 15.2542 19.5908 15.2542 20.4696C15.2542 21.9342 16.2878 23.1059 17.6168
            23.1059C18.6504 23.1059 19.5364 22.3736 19.5364 22.3736L19.6841
            22.9595H21.899V12.414H21.7513ZM17.6168 18.1261C17.6168 17.8332 17.9121 17.3938
            18.3551 17.3938C18.9457 17.3938 19.3887 17.5403 19.3887 17.5403V20.616C19.3887
            20.616 18.7981 21.0554 18.3551 21.0554C17.7644 21.0554 17.6168 20.616 17.6168
            20.4696C17.4691 19.5908 17.4691 18.8585 17.6168
            18.1261ZM22.342
            17.5403H23.3756V22.9595H25.8859V17.5403H27.8055V15.3433H25.8859V14.611C25.8859
            14.4645 26.0336 14.1716 26.3289 14.1716C27.0672 14.1716 27.9532 14.3181 27.9532
            14.3181L28.1008 12.2676C28.1008 12.2676 26.7719 12.1211 26.0336 12.1211C24.4093
            12.1211 23.5233 13.1463 23.5233 14.4645V15.3433H22.4897V17.5403H22.342Z"
            fill="#E30713"></path>
          </svg>
          <div class="title">Скачать расчет PDF</div>
        </div>
        <div @click="saveXls()" class="footer__item-download">
          <svg width="37" height="50" viewBox="0 0 37 50" fill="none"
           xmlns="http://www.w3.org/2000/svg">
            <path d="M1.51113 0C0.676709 0 0.000271502 0.678387 0.000265108 1.51522L0
            36.3639C-3.06158e-06 36.7658 0.159176 37.1512 0.442519 37.4354C0.725862 37.7195
            1.11016 37.8792 1.51087 37.8792H13.5972V34.8487H3.02175L3.02199 3.03047H25.6922C27.9648
            5.30303 30.3113 7.57576 33.3419 10.6063L33.3417 34.8487H22.662V37.8792H34.8525C35.6869
            37.8792 36.3634 37.2008 36.3634 36.3639L36.3636 9.30627C36.3636 9.03362 36.2904 8.76858
            36.1548 8.53761C36.0803 8.3471 35.9668 8.17021 35.8167 8.01967L28.2714 0.443847C27.9581
            0.129673 27.5304 -0.0248678 27.1037 0.00325872C27.0709 0.00109284 27.0378 0
            27.0047 0H1.51113Z" fill="#E30713"></path>
            <path d="M13.1544 41.3531C12.5644 40.7614 11.608 40.7614 11.018 41.3531C10.4281 41.9447
            10.4281 42.904 11.018 43.4956L17.0612 49.5563C17.6511 50.1479 18.6076 50.1479 19.1975
            49.5563L25.2407 43.4956C25.8307 42.904 25.8307 41.9447 25.2407 41.3531C24.6508 40.7614
            23.6943 40.7614 23.1044 41.3531L19.64 44.8274V30.303C19.64 29.4663 18.9637
            28.788 18.1294 28.788C17.2951 28.788 16.6187 29.4663 16.6187 30.303V44.8274L13.1544
            41.3531Z" fill="#E30713"></path>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.8964 15.0504H9.23848L11.7488
            18.712L9.09082 22.6665H11.7488L13.0777 20.616L14.259 22.6665H16.917L14.259
            18.712L16.7693 15.0504H14.1114L13.0777 16.808L11.8964
            15.0504ZM17.6553 22.813H20.0179V12.1211H17.6553V22.813ZM26.6627
            15.3433C26.6627 15.3433 25.3338
            15.0504 24.0048 15.0504C22.2328 15.0504 21.0515 15.7827 21.0515 17.3938C21.0515
            20.1767 24.5954 19.7373 24.5954 20.4696C24.5954 20.7625 24.4478 20.909 23.7095
            20.909C22.6758 20.909 21.3469 20.616 21.3469 20.616L21.0515 22.5201C21.0515 22.5201
            22.2328 22.9595 23.8571 22.9595C26.0721 22.9595 26.958 22.0807 26.958 20.4696C26.958
            17.8332 23.4141 18.2726 23.4141 17.5403C23.4141 17.2474 23.7095 17.1009 24.0048
            17.1009C24.8908 17.1009 26.2197 17.3938 26.2197 17.3938L26.6627 15.3433Z"
            fill="#E30713"></path>
            </svg>
          <div class="title">Скачать расчет excel</div>
        </div>
        <div @click="print()" class="footer__item-download">
          <svg width="40" height="50" viewBox="0 0 40 50" fill="none"
               xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0" mask-type="alpha" maskUnits="userSpaceOnUse"
                  x="0" y="0" width="40" height="50">
              <rect width="40" height="50" fill="#45FF94"></rect>
            </mask>
            <g mask="url(#mask0)">
            <path fill-rule="evenodd"
                  clip-rule="evenodd" d="M10.1199 5C9.28052 5 8.60006 5.68877 8.60006
                  6.5384V17.3061C8.60006 18.1558 9.28052 18.8445 10.1199 18.8445H31.4001C32.2174
                  18.8445 32.884
                  18.1915 32.9185 17.3728H35.0381C35.7021 17.3728 35.9603
                  17.8336 35.9603 18.0756V32.6919C35.9603 32.8496 35.8973
                  33.0023 35.7407 33.1409C35.5736 33.2888 35.3205 33.3947
                  35.0381 33.3947H32.9199V31.1531C32.9199 30.3035 32.2395
                  29.6147 31.4001 29.6147H10.1199C9.28052 29.6147 8.60006
                  30.3035 8.60006 31.1531V43.4616C8.60006 44.3112 9.28052
                  45 10.1199 45H31.4001C32.2395 45 32.9199 44.3112 32.9199
                  43.4616V36.4715H35.0381C36.9645 36.4715 39 35.0267 39 32.6919V18.0756C39
                  15.9585 37.2017 14.296 35.0381 14.296H32.9199V6.5384C32.9199 5.68877
                  32.2395 5 31.4001 5H10.1199ZM11.6398
                  15.7677V8.0768H29.8802V15.7677H11.6398ZM11.6398
                  41.9232V32.6915H29.8802V41.9232H11.6398Z" fill="#E30713"></path>
            <path d="M8.59991 14.296H4.96194C2.98078 14.296 1 15.9081 1
            18.0756V32.6919C1 34.809 2.79828 36.4715 4.96194
            36.4715H8.59991V33.3947H4.96194C4.29793 33.3947 4.03972
            32.934 4.03972 32.6919V18.0756C4.03972 18.0028 4.08152 17.8343
            4.27979 17.6524C4.47435 17.4738 4.72824 17.3728 4.96194 17.3728H8.60132C8.60038
            17.3507 8.60006 17.3285 8.60006 17.3061L8.59991 14.296Z" fill="#E30713"></path>
            <path d="M8.59991 21.922C7.76051 21.922 7.08005 22.6107 7.08005
            23.4604C7.08005 24.31 7.76051 24.9988 8.59991 24.9988H10.1199C10.9593
            24.9988 11.6398 24.31 11.6398 23.4604C11.6398 22.6107 10.9593 21.922 10.1199
            21.922H8.59991Z" fill="#E30713"></path>
            </g>
          </svg>
          <div class="title">Распечатать расчет</div>
        </div>
        <div class="footer__item-save"
         @mouseover="isHover = !isHover"
         @mouseleave="isHover = !isHover"
         @click="goToSavePage()">
          <div class="img">
            <img src="@/assets/img/cloud.svg" alt="save">
          </div>
          <div class="content">
            <div class="content__title">
              Сохранить расчет
            </div>
            <div class="content__text">Все параметры и расчетные данные
              будут сохранены и доступны по ссылке
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { dataLayerPushEvent } from '@/utils/GTM';

export default {
  data() {
    return {
      isHover: false,
      name: 'Yuriy',
    };
  },
  methods: {
    goToSavePage() {
      dataLayerPushEvent('calc-wedge-insulating-save');
      this.$router.push('/save/');
    },
    print() {
      dataLayerPushEvent('calc-wedge-insulating-print');
      window.print();
    },
    savePdf() {
      dataLayerPushEvent('calc-wedge-insulating-download-simple');
      this.$emit('savePdf');
    },
    saveXls() {
      dataLayerPushEvent('calc-wedge-insulating-download-complex');
      this.$emit('saveXls');
    },
  },
  components: {
  },
};
</script>

<style lang="sass" scoped>
.prefooter
  background: #fff
  +media((margin-top: (320: rem(48), 960: rem(68))))
.footer
  position: relative
  &:after
    content: ""
    height: 100%
    width: calc((100vw - 100%) /2 )
    right: calc(((100vw - 100%) /2) * -1 )
    top: 0
    background: $red
    position: absolute
    transition: .5s
  &.hovered
    &:after
      background: $red-hover
  &__item
    &-download
      color: $black
      background: #fff
      box-shadow: inset rem(-1) 0 0 #ECECEC
      display: flex
      flex-direction: column
      justify-content: center
      align-items: center
      transition: .5s
      cursor: pointer
      text-decoration: none
      +media((width: (320: calc(100% / 3), 960: rem(200))))
      +media((height: (320: rem(144), 960: rem(170))))
      .title
        font-style: normal
        font-weight: 500
        text-align: center
        +media((padding: (320: rem(19) 0 0, 960: rem(19) 0 0)))
        +media((max-width: (320: rem(78), 960: unset)))
        +media((font-size: (320: rem(12), 960: rem(14))))
        +media((line-height: (320: rem(20), 960: rem(30))))
      svg
        path
          transition: .5s
      &:hover
        background: $red
        color: #fff
        .title
          font-weight: bold
        svg
          path
            fill: #fff
    &-save
      background: $red
      display: flex
      flex-direction: row
      align-items: center
      max-width: rem(360)
      text-decoration: none
      transition: .5s
      position: relative
      cursor: pointer
      +media((padding: (320: rem(28) rem(24) rem(34), 960: 0)))
      +media((max-width: (320: unset, 960: rem(360))))
      +media((width: (320: 100%, 960: auto)))
      &:hover
        background: $red-hover
      .img
        pointer-events: none
        +media((padding: (320: 0 rem(24) 0 0, 960: 0 rem(33))))
      .content
        color: #fff
        text-align: left
        pointer-events: none
        &__title
          font-style: normal
          font-weight: bold
          padding-bottom: rem(14)
          +media((font-size: (320: rem(20), 960: rem(24))))
          +media((line-height: (320: rem(24), 960: rem(29))))
        &__text
          font-style: normal
          font-weight: 600
          font-size: rem(12)
          line-height: rem(20)
</style>
